import { useParams } from "react-router";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "@refinedev/react-hook-form";

import { AgreementPlanFormValues, agreementPlanSchema } from "@modules/agreementPlans/validations";
import { useEditAgreementPlanMutation } from "@modules/agreementPlans/services/mutations";

export function useAgreementPlanEditForm() {
  const { id } = useParams();
  const { mutateAsync, isPending } = useEditAgreementPlanMutation(id as string);

  const methods = useForm<AgreementPlanFormValues>({
    resolver: zodResolver(agreementPlanSchema()),
    mode: "onBlur",
  });

  const {
    handleSubmit,
    refineCore: { formLoading },
  } = methods;

  return {
    methods,
    handleSubmit,
    mutateAsync,
    isPending,
    formLoading,
    id,
  };
}
